import VueRouter from 'vue-router'
import routes from './routes'
import store from '../store/index'


const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, _, next) => {
    store.dispatch('auth/updateToken').then();
    let isSuccess = false;

    if (to.meta.public) return next(true)
    if (to.meta.auth && store.getters["auth/isAuth"] && !to.meta.gateName) return next(true)
    store.getters['auth/getCredits'].forEach((credit) => {
        if (credit.name === to.meta.gateName) {
            isSuccess = true
        }
    })
    if (isSuccess) {
        return next(true)
    } else {
        return next('/ErrorForbiden')
    }
})



export default router
